import styled from "@emotion/styled";
import { getAssetUrl } from "../../../utils/constants";
import { StyledImage } from "../../../components/Image/Image";

export const ProductImage = styled(StyledImage)<{ grayscale: boolean }>`
  object-position: center;
  filter: ${({ grayscale }) => (grayscale ? "grayscale(100%)" : "none")};
  background: url(${getAssetUrl("Wishlink-logo.png")}) no-repeat center center;
  background-size: 48px 48px;
  background-position: 50% 50%;
`;

export const StyledLink = styled.a<{ color: string }>`
  text-decoration: underline;
  color: ${({ color }) => color};
`;
